/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum QuoteTestExpectationType {
  QuotePriceByCarrer = "quote_price_by_carrer",
  RequestRegex = "request_regex",
  ResponseRegex = "response_regex",
}

export function instanceOfQuoteTestExpectationType(value: any): boolean {
  for (const key in QuoteTestExpectationType) {
    if (Object.prototype.hasOwnProperty.call(QuoteTestExpectationType, key)) {
      if (
        QuoteTestExpectationType[
          key as keyof typeof QuoteTestExpectationType
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function QuoteTestExpectationTypeFromJSON(
  json: any,
): QuoteTestExpectationType {
  return QuoteTestExpectationTypeFromJSONTyped(json, false);
}

export function QuoteTestExpectationTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): QuoteTestExpectationType {
  return json as QuoteTestExpectationType;
}

export function QuoteTestExpectationTypeToJSON(
  value?: QuoteTestExpectationType | null,
): any {
  return value as any;
}

export function QuoteTestExpectationTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): QuoteTestExpectationType {
  return value as QuoteTestExpectationType;
}
